import { useEffect, useState } from "react";
import { AdminInterface } from "../../interfaces/admin.interface";
import { get, post } from "../../redux/ApiHelper";
import { successToast } from "../../utils/toast.util";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const SelectAdminInput = ({
  isOpen,
  closeModal,
  selectedParentId,
}: {
  isOpen: boolean;
  closeModal: () => void;
  selectedParentId;
}) => {
  const [admins, setAdmins] = useState<AdminInterface[]>([]);
  const [results, setResults] = useState<AdminInterface[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedAdminId, setSelectedAdminId] = useState<string | null>(null);
  const { signedAdmin } = useSelector((state: RootState) => state.admin);

  useEffect(() => {
    if (signedAdmin.type === "franchise") {
      setAdmins([{ ...signedAdmin, _id: signedAdmin.id }]);
      setResults([{ ...signedAdmin,_id: signedAdmin.id }]);
    }
    if (signedAdmin.type === "employee") {
      get("/admin/admin/get-active-admins").then((res) => {
        // const filtered = res.filter((admin)=> admin.email === signedAdmin.email);
        setAdmins(res);
        setResults(res);
      });
    }
  }, []);

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    const filtered = admins.filter(
      (admin) =>
        admin.name?.toLowerCase().includes(query) ||
        admin.email.toLowerCase().includes(query)
    );
    setResults(filtered);
  }, [searchQuery, admins]);

  const handleSubmit = async () => {
    if (!selectedAdminId || !selectedParentId) return;
    try {
      await post("/admin/admin/assign", {
        adminId: selectedAdminId,
        parentId: selectedParentId,
      })
        .then((res) => {
          // console.log(res);
          successToast(res.message);
          closeModal();
        })
        .catch((error) => {});
      closeModal();
    } catch (err) {
      console.error("Error assigning admin:", err);
    }
  };

  if (!isOpen) return null;

  console.log(results);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-lg mx-4 p-6 rounded-lg shadow-lg max-h-screen overflow-auto">
        {/* Header */}
        <div className="mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Assign Admin</h2>
        </div>

        {/* Search Input */}
        <div className="space-y-4">
          <div>
            <label
              htmlFor="search"
              className="block text-left text-gray-700 mb-1"
            >
              Search Admin
            </label>
            <input
              type="text"
              name="search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search by name or email"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Admin List */}
          <div className="max-h-64 overflow-y-auto">
            {results.length > 0 ? (
              results.filter((admin) => admin.type === 'franchise').map((admin) => (
                <div
                  key={admin._id}
                  onClick={() => setSelectedAdminId(admin._id)}
                  className={`cursor-pointer w-full rounded mb-3 p-3 border ${
                    selectedAdminId === admin._id
                      ? "border-yellow-600 bg-yellow-100"
                      : "border-gray-300"
                  }`}
                >
                  <div
                    className={`font-medium ${
                      selectedAdminId === admin._id ? "text-yellow-700" : ""
                    }`}
                  >
                    {admin.name || "Unnamed"} - {admin.email} - {admin.type}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-gray-500">No matching admin found.</div>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={closeModal}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-white bg-yellow-600 rounded-md hover:bg-yellow-700 transition disabled:opacity-50"
            disabled={!selectedAdminId}
          >
            Assign Admin
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectAdminInput;
